import {
    GET_ALLDEFAULTPRODUCT_SUCCESS,
    GET_ALLDEFAULTPRODUCT_FAILURE,
    PRODUCT_TEMPLATE_EDIT_SUCCESS,
    PRODUCT_TEMPLATE_EDIT_FAILURE,
    SELECTED_DEFAULT_PRODUCT
} from '../DefaultProduct/action';
const initialState = {
    defaultProductListSuccess: [],
    defaultProductListFailure: [],
    productTemplateEditSuccess: [],
    productTemplateEditFailure: [],
    selectedDefaultProduct: {}
}

const allDefaultProductReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALLDEFAULTPRODUCT_SUCCESS:
            return state = {
                ...state,
                defaultProductListSuccess: action.data
            }
        case GET_ALLDEFAULTPRODUCT_FAILURE:
            return state = {
                ...state,
                defaultProductListFailure: action.data
            }
        case PRODUCT_TEMPLATE_EDIT_SUCCESS:
            return state = {
                ...state,
                productTemplateEditSuccess: action.data
            }
        case PRODUCT_TEMPLATE_EDIT_FAILURE:
            return state = {
                ...state,
                productTemplateEditFailure: action.error
            }
        case SELECTED_DEFAULT_PRODUCT:
            return state ={
                ...state,
                selectedDefaultProduct: action.product
            }
        default: return state
    }
}
export default allDefaultProductReducer;
